import { createStyles, Grid, makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AdminBreadCrumbs } from '../../../../layouts/AdminBreadCrumbs/AdminBreadCrumbs';
import { routes } from '../../../../routes';
import { FileSelectButton } from '../../../../shared/Components/FileSelectButton';
import ProductCatalogPriceImportSidebar from './ProductCatalogPriceImportSidebar';

export default function ProductCatalogPriceImport(): JSX.Element {
  const classes = useStyles();
  const { t } = useTranslation();

  const [addedDocument, setAddedDocument] = useState<File | null>(null);

  function handleAddNewDocument(addedFiles: File[]) {
    if (addedFiles.length !== 1) {
      return;
    }

    const addedFile = addedFiles[0];
    setAddedDocument(addedFile);
  }

  return (
    <>
      <AdminBreadCrumbs sites={[t('Import')]} links={[routes.Import()]} />
      <Grid container>
        <Grid item xs={8} className={classes.containerBase}>
          <div className={classes.Title}>{t('Produktkatalog Preisimport')}</div>
          <Grid container>
            <Grid item xs={12} container justifyContent='space-between'>
              <Grid item xs={4}>
                <FileSelectButton
                  onFilesSelected={handleAddNewDocument}
                  color='primary'
                  accept={[
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // XLSX
                    'application/vnd.ms-excel', // XLS
                  ]}
                  warningText={t('Nur Excel Dateien sind erlaubt')}
                  text={t('Hochladen')}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {addedDocument && (
          <Grid item xs={4} className={classes.sidebar}>
            <ProductCatalogPriceImportSidebar
              productPriceImportFile={addedDocument}
              onSubmit={() => setAddedDocument(null)}
              onCancel={() => setAddedDocument(null)}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
}

export {};

const useStyles = makeStyles(() =>
  createStyles({
    containerBase: {
      paddingLeft: '20px',
    },
    sidebar: {
      marginTop: '-135px',
      minHeight: '100%',
      backgroundColor: 'white',
    },
    Title: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 300,
      fontSize: '36px',
      marginBottom: '24px',
    },
    '& .MuiDataGrid-footerContainer': {
      minHeight: 0,
      height: 0,
    },
  })
);
